import { Box } from '@veracity/vui'
import styled from 'styled-components'

export const BorderedBox = styled(Box)`
  border: 1px solid hsl(30, 8%, 85%);
`
